/**
 * Initialise switchers
 * @param {NodeList} switcherEls DOM nodes that represent the colour switchers
 */
function initialiseSwitchers(switcherEls) {
  switcherEls.forEach((switcherEl) => {
    const switcherId = switcherEl.dataset.id;
    const defaultIndex = switcherEl.dataset.defaultIndex;
    const paletteJson = JSON.parse(switcherEl.dataset.palette);
    const ulEl = document.createElement('ul');
    ulEl.classList.add('colour-switcher__palette');

    // Set colours using defaultIndex values
    setColours(
      switcherId,
      paletteJson[defaultIndex].background,
      paletteJson[defaultIndex].text,
    );

    // Build out markup for each colour in the palette
    paletteJson.forEach((colour, i) => {
      const text =
        colour.text === 'light'
          ? 'var(--colour-inverse-body)'
          : 'var(--colour-primary-body)';
      const isDefault = parseInt(defaultIndex, 10) === i;
      const liEl = document.createElement('li');
      const buttonEl = document.createElement('button');

      buttonEl.insertAdjacentHTML(
        'beforeend',
        `<span class="visually-hidden">${colour.label}</span>`,
      );

      liEl.appendChild(buttonEl);
      ulEl.appendChild(liEl);

      buttonEl.ariaPressed = isDefault ? true : false;
      buttonEl.type = 'button';
      buttonEl.classList.add('colour-switcher__button', 'button');
      buttonEl.dataset.background = colour.background;
      buttonEl.dataset.text = text;

      // Use style to pass CSP checks
      buttonEl.style.setProperty(
        '--switcher-button-background',
        colour.background,
      );
      buttonEl.style.setProperty('--switcher-button-text', text);

      // Attach events
      buttonEl.addEventListener('click', () => {
        // Set colours using button specific values
        setColours(switcherEl.dataset.id, colour.background, colour.text);
        ulEl.querySelector(
          '.colour-switcher__button[aria-pressed="true"]',
        ).ariaPressed = false;
        buttonEl.ariaPressed = true;
      });

      // Insert into the DOM
      switcherEl.insertAdjacentElement('beforeend', ulEl);
    });
  });
}

/**
 * Set the background / text colour using custom props
 * @param {String} id - id used to make a unique custom prop
 * @param {String} backgroundColour - Colour value, could be hex/rgba/hsl etc
 * @param {String} textColour - Colour value, could be hex/rgba/hsl etc
 */
function setColours(id, backgroundColour, textColour) {
  document.documentElement.style.setProperty(
    `--switcher-${id}-background`,
    backgroundColour,
  );
  document.documentElement.style.setProperty(
    `--switcher-${id}-text`,
    textColour === 'dark'
      ? 'var(--colour-primary-body)'
      : 'var(--colour-inverse-body)',
  );
}

export default document.addEventListener('DOMContentLoaded', function () {
  const switcherEls = document.querySelectorAll('.colour-switcher');
  // Initialise each switcher
  initialiseSwitchers(switcherEls);
});
